export const projects = [
    {
        id: "terror_engine_game",
        name: "Runtime Terror Engine",
        description: "Simple 2D game engine, complete with a game editor UI",
        details: "A game engine that can be used to build 2D games using python scripts. The game engine focuses on providing clean and easy-to-use APIs and a friendly game editor UI that helps users in creating games with relative ease. The core engine APIs are implemented in C++ and the game itself runs in a C++ environment - so its all the performance benefits that comes with using C++ without the mess of handling memory issues and object lifecycles. Pybind is used to create python bindings for native C++ APIs and PyQt is used for creating the editor UI. Apart from these Box2d is built-into the engine APIs bringing life-like physics to any game you make.",
        associatedWith: "MS Computer Science, Northeastern University",
        duration: "March 2021 - April 2021",
        domain: "Game Development",
        primaryLanguage: "C++",
        skills: [
            "Graphics",
            "Data Structures",
            "Entity Component System",
            "Object-Oriented Design",
        ],
        technologiesUsed: [
            "SDL2",
            "Pybind11",
            "PyQt",
            "CMake",
            "Git"
        ],
        github: "private",
        projectUrl: "",
        projectDemo: "",
        images: [
            {
                source: require("../../../assets/showcase/terror_engine/terror-engine-1.webp"),
                description: "The Game Editor UI ✨"
            },
            {
                source: require("../../../assets/showcase/terror_engine/terror-engine-2.webp"),
                description: "A Bundled Tile Editor 🧩"
            },
            {
                source: require("../../../assets/showcase/terror_engine/terror-engine-3.webp"),
                description: "And this is one of many games you can make with it 🎮"
            }
        ],
        packageLink: "",
        video: "https://www.youtube.com/embed/PEjhtEvKzxQ",
        showcase: true,
        postMortem: "Building a Game Engine is an extremely challenging task, so there are a lot of things that could be improved in this project, some of them are - \n1. Game Editor UI \nCurrently, the preview window can be used to preview a game object when loaded with a custom sprite. But due to time constraint, implementation of relative positioning of these objects that will be rendered in the game could not be completed. Also, the functionality of being able to drag and drop game objects and tiles in respective positions such that the same layout will be rendered in the game could also be added.\n\n2. Menu - \nCurrently, this game engine doesn't support a menu component. So user needs to achieve it using existing components manually, which is a hard work.\n\n3. Game object AI - \nThis game engine doesn't support AI, so users need to create it by themselves. This can improved it by supporting some default behaviors of AI.\n\n4. Physics - \nAlthough Box2D is used to handle the collision and physics, the behavior of physics can be improved by solving the problem where objects in the game might stick at somewhere. Also the physics properties of objects are limited due to Box2D. For example, currently an object can not pass through another object and raise contact callback without collision - Sensors are possible way to fix this bug.\n\n5. Different Tile properties - \nFor now, tiles have same properties. the user should be allowed to add custom properties to the tile, for instance, different tiles have different friction, or some tiles could be destroyed by player.",
        pinned: true,
    },
    {
        id: "berry_ninja_game",
        name: "Berry Ninja",
        description: "A 2D Platformer game set in the magical berry land!",
        details: "The game is a 2D platformer built in bare-bones C++ using only SDL2 for graphics rendering. The game's objective is to avoid contact with the enemies that come in a way by jumping over them. The player has limited health and any contact with enemy or falling off of the cliffs will result in damage. The player & enemy movements are beautifully animated with 🔊️ custom sounds heard throughout this short but fun game. There is also checkpoints along the way, so don't worry if you fall off the platform, you revive to the last checkpoint... at least till you have lives left 😈️.",
        associatedWith: "MS Computer Science, Northeastern University",
        duration: "March 2021",
        domain: "Game Development",
        primaryLanguage: "C++",
        skills: [
            "Graphics",
            "Data Structures",
            "2D Game Physics",
            "Entity Component System",
            "Object-Oriented Design",
            "Vector Math"
        ],
        technologiesUsed: [
            "SDL2",
            "CMake",
            "Git"
        ],
        github: "private",
        projectUrl: "",
        projectDemo: "",
        images: [
            {
                source: require("../../../assets/showcase/berry_ninja/berry-ninja-1.webp"),
                description: "Collect all the berrys of the mystic berry land! 🍋🍈🍓"
            },
            {
                source: require("../../../assets/showcase/berry_ninja/berry-ninja-2.webp"),
                description: "Jump (or Double Jump 😉️) your way through the level !"
            },
            {
                source: require("../../../assets/showcase/berry_ninja/berry-ninja-3.webp"),
                description: "Beware of the enemies though! 💀️"
            },
            {
                source: require("../../../assets/showcase/berry_ninja/berry-ninja-4.webp"),
                description: "A trophy awaits you! 🏆️"
            }
        ],
        packageLink: "https://drive.google.com/file/d/1wryNajrPjpvx9sbtqXC73_MLI3ErgZ4N/view?usp=sharing",
        video: "https://www.youtube.com/embed/CVmyVcldleg",
        showcase: true,
        postMortem: "In the time frame this project was completed, there were certain things that we could add to make the game more 'interesting'. For instance, \n1. Levels \nOur game currently supports only one level so first thing to improve or work upon would adding more levels. Also, the level right now is fairly simple to play, making it more challenging and also more engaging could be fun.\n\n2. Main Menu and Pause Screen\nWhen a user starts up the game, they are taken directly into it without any menu for navigation. A Main menu to start, read instructions, select levels and quit the game needs to be implemented. Also, we might have to add a Pause functionality and a Pause screen to the game to improve the user experience.\n\n3. Multiple Language Support\nThe game currently supports English to display text on screen. Additional language support can be added.\n\n4. Collisions\nCollision logic in the game is simple and does most of the job. But when the player can see some jagged movement while colliding with the tiles. A much robust collision detection and response physics needs to added to make the player movement smooth and seamless.\n\n5. Enemy AI\nEnemy AI in our game has a simple behavior - patrol a given line from one edge to the other. This can be improved upon by making the AI pursue the player in a given range or zone.\n\n6. Fighting back\n The player cannot attack or cause damage to the enemies present in the game. We want that to change: giving the player a weapon such as a sword or making the player eliminate enemies by jumping on them in Mario fashion can be be worked upon.\n\n7. Different Tile properties -\nAll the tiles in the game have a simple physics component which checks for collisions and performs the necessary collision response. We would like to add custom properties to certain tiles such as making them more slippery, dishing out damage when walked upon etc.",
        pinned: true,
    },
    {
        id: "breakout_game",
        name: "Breakout Game",
        description: "A recreation of the classic Atari Breakout Game!",
        details: "The classic Atari breakout game built with SDL2 and modern C++. The game is built with minimal third party libraries and can be played using a keyboard. The gameplay is enhanced by addition of custom levels that can be rendered from simple text files - allowing the end user to create and design their own levels. There are 3 provided levels and the player starts with 3 lives. If you clear a level you are automatically promoted to the next level. The game also features 8-bit sounds to enhance user-experience. You can press q to quit the game anytime you want.",
        associatedWith: "MS Computer Science, Northeastern University",
        duration: "February 2021",
        domain: "Game Development",
        primaryLanguage: "C++",
        skills: [
            "Graphics",
            "Data Structures",
            "Object-Oriented Design",
            "Vector Math"
        ],
        technologiesUsed: [
            "SDL2",
            "Git",
        ],
        github: "private",
        projectUrl: "",
        projectDemo: "",
        images: [
            {
                source: require("../../../assets/showcase/breakout/breakout1.png"),
                description: "Create Custom Levels !"
            },
            {
                source: require("../../../assets/showcase/breakout/breakout2.png"),
                description: "Multiple Language Support - English & French !"
            },
            {
                source: require("../../../assets/showcase/breakout/breakout3.png"),
                description: "Complete level by destroying all bricks"
            }
        ],
        packageLink: "https://drive.google.com/file/d/1b3lQ8C3Q0sKCJDYeA3jWtmj4VubAF2O3/view?usp=sharing",
        video: "https://www.youtube.com/embed/ZQhatV8RSy8",
        showcase: true,
        postMortem: "Given the 2 weeks time in which this game was required to be built from scratch up without using any existing code or libraries except SDL, the final product was reasonable and met the minimum requirements. There were a few areas in which this project could be improved though and the following 2 segments would be where I would invest most of my time. \n\nGeneral Software Engineering - \n1. There was no unit testing done due to limited time frame. Following TDD is extremely difficult when there is a tight deadline. I would have used Catch2 framework to unit test the core classes in the code base. \n2. In general, the inputs to the most public classes was not validated and exception handling was mostly non-existant. There could be some comprehensive exception handling that could be implemented.\n3. There was no enforcing of making sure that all objects in the game inherited from a common class. This is essential because some functionality should be fundamental to all game objects. I attempted to make Position2DAware as this class, but it was mostly used as interface.\n\nGame Management & Architecture - \n1. The architecture used in this game did not scale quite well when adding new features. For instance the level loading & management is still fairly complex, involving the use of multiple flags even when there is a dedicated class for this purpose.\n2. The GameObjects should have a universal ID manager that can recognize objects from the ID. This feature may come in handy.There could be a dedicated particle system that could be used to render particles that appear momentarily and then disappear. This effect could help in better graphics experience when ball collides with the bricks.\n3. The resource IDs are currently the names of actual resource files, there could be a better way to do this.\n There could also be some optimization tweaks so that the game uses less resources, but given that this is a simple 2D game and works smoothly, I would prioritize the above mentioned details over minor optimizations.",
        pinned: false,
    },
    {
        id: "co_text",
        name: "Collaborative Text Editor",
        description: "Cross-platform, decentralized C++ based text editor that allows multiple users to collaborate simultaneously in real-time",
        details: "The application has a working GUI built using SFML and was majorly focused on accurately resolving insert-delete conflicts that arise when multiple users simultaneously issue operations on the shared text.\nThe project employed the use of advanced distributed systems concepts like CRDTs (Conflict- Free Replication Data Types) and Version Vectors to maintain consistency across multiple clients.\nSince the the app was decentralized (peer-to-peer), there was no central server and the individual peers contained the business logic for achieving and maintaining consistency.\nUDP networking was used in order to achieve real-time performance.",
        associatedWith: "MS Computer Science, Northeastern University",
        duration: "November 2020 - December 2020",
        domain: "Desktop App Development",
        primaryLanguage: "C/C++",
        skills: [
            "Distributed Systems",
            "Networking",
            "Graphics",
            "Multithreading"
        ],
        technologiesUsed: [
            "Git",
            "SFML",
            "CRDT",
            "Version Vectors",
            "Boost C++",
        ],
        github: "https://github.com/psx95/collaborative-text-editor",
        projectUrl: "",
        projectDemo: "https://www.youtube.com/watch?v=_Qp0ZRKyG-I",
        images: [],
        pinned: true,
    },
    {
        id: "portfolio_website",
        name: "Portfolio Website",
        description: "A personal portfolio website created to showcase my work",
        details: "This is the website you are currently viewing 😁.\nIt's a single page web application that serves as my personal portfolio website. Material design principles were followed while designing the website and it is built using React.JS. The main focus of this project was at responsive design so that it looks good on any screen size.",
        associatedWith: "Personal Project",
        duration: "May 2020",
        domain: "Web Development",
        primaryLanguage: "Javascript",
        skills: [
            "Responsive Design",
            "Material Design",
        ],
        technologiesUsed: [
            "Git",
            "React.JS",
            "HTML5/CSS3",
            "Material-UI",
            "Firebase",
        ],
        github: "proprietary",
        projectUrl: "",
        projectDemo: "",
        images: [],
        pinned: false,
    },
    {
        id: "excercise_db",
        name: "Exercise Database",
        description: "Exercise Database is a simple web app that maintains a list of physical exercises",
        details: "This project was developed as an attempt to learn React.JS and front-end website design and development. The highlight of the website is that it is built with the principles of Material Design and uses a popular framework called Material-ui. The website is extremely repsonsive and works well with all devices including mobile devices. The project does not contain an actual database, but CRUD operations were implemented and UI is made to reflect the changes of these CRUD operations.",
        associatedWith: "Personal Project",
        duration: "May 2020",
        domain: "Web Development",
        primaryLanguage: "Javascript",
        skills: [
            "Website Design",
            "Material Design",
        ],
        technologiesUsed: [
            "Git",
            "React.JS",
            "HTML5/CSS3",
            "Material-UI",
        ],
        github: "https://github.com/psx95/exercises-app-material-ui",
        projectUrl: "",
        projectDemo: "",
        images: [],
        pinned: false,
    },
    {
        id: "sketch_it",
        name: "Sketch-It!",
        description: "Sketch-It is a collaborative painting application developed in C/C++ that can run on Linux, Windows & MacOS",
        details: "The application has networking capabilities, where in you and your teammates can draw on the same canvas when connected to the same server. Leveraging the speed of UDP network protocol, the application offers smooth painting experience with almost no lag across the network (Tested with up-to 5 people drawing on the same canvas).\nThe users have various options for drawing including various colors and 3 different paintbrushes - pixel brush, pencil strokes and air brush.\nThe users can also communicate with each other using a GUI based group chat option.",
        associatedWith: "MS Computer Science, Northeastern University",
        duration: "March 2020 - April 2020",
        domain: "Desktop App Development",
        primaryLanguage: "C/C++",
        skills: [
            "Data Structures",
            "Design Patterns",
            "Networking",
            "Graphics",
        ],
        technologiesUsed: [
            "Git",
            "Continuous Integration",
            "SFML",
            "Nuklear - Immediate Mode UI",
        ],
        github: "private",
        projectUrl: "",
        projectDemo: "https://www.youtube.com/watch?v=UZgpGAGbAuk&t=1s",
        images: [],
        pinned: true,
    },
    {
        id: "meeting_log",
        name: "Meeting Log",
        description: "Meeting Log is a simple web app to create & manage meetings",
        details: "Meeting Log app offers a simple login/registration form to allow user to log in and resgiter. Once logged in, the user can create new meetings and view his existing meetings.\nThe creator of the meeting can then check-in people into the meetings and the application also allows for searching a particular attendee in the list of checked-in guests. The meetings and all the related data is stored in a database and therefore is available when the user logs back in.\nFirebase is used for database and user authentication.",
        associatedWith: "Personal Project",
        duration: "Decemeber 2019 - January 2020",
        domain: "Web Development",
        primaryLanguage: "Javascript",
        skills: [
            "Website Design",
            "Database Design",
        ],
        technologiesUsed: [
            "Git",
            "React.JS",
            "HTML5/CSS3",
            "Firebase",
        ],
        github: "https://github.com/psx95/react-meeting-log-app",
        projectUrl: "",
        projectDemo: "",
        images: [],
        pinned: false,
    },
    {
        id: "fun_with_images",
        name: "Fun with Images",
        description: "Fun with Images is a GUI based Image Editing desktop application created in Java",
        details: "The application follows a model-view-controller design pattern and is designed to scale well over-time as features add up. The GUI is built using Java swings and use multi-threading for better user-experience. The application offers various filters such as Sepia, Mosaic, Gray-scale, Dither, Sharpen & Blur. The application also allows the user to specify intensity for some of these filters.\nOther than applying filters on preexisting images, the user also has option to generate images. These are basically images which follow a mathematical pattern like rainbow strips & checkerboard.\nYou can also generate flags of supported countries - like France, Switzerland & Greece in various sizes. The aspect ratio is maintained by the application.",
        associatedWith: "MS Computer Science, Northeastern University",
        duration: "November 2019 - December 2019",
        domain: "Desktop App Development",
        primaryLanguage: "Java",
        skills: [
            "Design Patterns",
            "Object Oriented Design",
            "Graphical User Interface",
        ],
        technologiesUsed: [
            "Git",
            "Java Swings",
        ],
        github: "private",
        projectUrl: "",
        projectDemo: "",
        images: [],
        pinned: true,
    },
    {
        id: "review_classifier",
        name: "Review Classifier",
        description: "Review Classifier is a simple text classifier that classifies reviews as negative or positive",
        details: "This project is an implementation of a TextClassifier based on bag-of-words, naive Bayes classifier using add-1 (Laplace) smoothing. This classifier is used to classify movie reviews in positive and negative. The training data for this “sentiment analysis” task were first assembled and published in Bo Pang and Lillian Lee, “A Sentimental Education: Sentiment Analysis Using Subjectivity Summarization Based on Minimum Cuts”, Proceedings of the Association for Computational Linguistics, 2004.\nThe project does not have a GUI and runs on command line interface, following a command design pattern. The two main commands are nbtrain and nbtest - used to train and test the dataset repsectively.\nThe nbtrain command outputs a JSON file contains the estimates determined based on the pre-classified training data. This file is used as an input for the nbtest command.\nThe The output of nbtest command is a user specified file (typically a .txt) that contains the result of classification. The result is basically the file name (that was classified) along with the classification ontology (POSITIVE/NEGATIVE) and their relative probability scores.",
        associatedWith: "MS Computer Science, Northeastern University",
        duration: "November 2019 - December 2019",
        domain: "Desktop App Development",
        primaryLanguage: "Java",
        skills: [
            "Data Classification",
            "Information Retrieval",
            "Design Patterns",
        ],
        technologiesUsed: [
            "Git",
        ],
        github: "private",
        projectUrl: "",
        projectDemo: "",
        images: [],
        pinned: false,
    },
    {
        id: "focussed_crawler",
        name: "Focussed Crawler",
        description: "Focussed Crawler is a web crawler that can crawl documents from Wikipedia",
        details: "This project is a focused crawler, implemented in Java 8. The crawler is able to crawl the Wikipedia pages with only link prefixes with https://en.wikipedia.org/wiki/. The crawler goes to a max depth of 5 from the root url (also called the seed document) to insure completion of program.\nThe crawler works on a command line interface and can run in 2 modes - focussed mode and general mode. In the focussed mode, the crawler accepts a seed document and a search keyphrase from the user and crawls and returns only the documents that are relevant with respect to the inputted keyphrase.\nIn general mode, the crawler only crawls documents from the seed page - going to whatever link it finds first in the document assuming all documents are relevant. The crawler will only crawl a maximum of 1000 documents.\nAdditionaly, the crawler can also compare the results from a focussed crawl and general crawl returning % overlap of documents between the two modes.",
        associatedWith: "MS Computer Science, Northeastern University",
        duration: "September 2019",
        domain: "Desktop App Development",
        primaryLanguage: "Java",
        skills: [
            "Information Retrieval",
            "Design Patterns",
            "Object Oriented Design",
        ],
        technologiesUsed: [
            "Git",
        ],
        github: "private",
        projectUrl: "",
        projectDemo: "",
        images: [],
        pinned: false,
    },
    {
        id: "vrc",
        name: "Variable Rate Controller",
        description: "Variable rate controller is a software that helps in precision agriculture by allowing optimum use of fertilizers in a given field",
        details: "VRC app is implemented on the Android OS and can be installed on a phone/tablet which is then fixed on the vehicle to which the spraying equipment is attached. The app would accept the current location data from the IoT device attached to spraying equipment and would calculate the optimum amount of fertilizer required at that position in the given field.\n The app also contains a 3D guidance system for navigation in the field. The primary purpose of this guidance system is to allow the driver of the vehicle to drive the vehicle in straight lines - as in precision agriculture, if the driver deviates from the path by a small amount, it leads to wastage of money and resources. The 3D guidance system is implemented using the Unity3D game engine and is then incorporated into native Android code.\nThe Android app architecture relied heavily on the use of Fragments to support various screen sizes from Mobile Phones to Tablets. The app also implements a multi-process approach to improve performance. Inter process communication was implemented using various services.",
        associatedWith: "Software Development Engineer (Android Lead), Carnot Technologies Pvt. Ltd.",
        duration: "March 2019 - May 2019",
        domain: "Android Development",
        primaryLanguage: "Java",
        skills: [
            "Android",
            "Algorithm Design",
            "Data Structures",
            "Asynchronous Programming",
            "Design Patterns",
            "Networking",
            "Object Oriented Design",
            "Multi-processing",
        ],
        technologiesUsed: [
            "Git",
            "RxJava",
            "RxAndroid",
            "Unity 3D",
            "Firebase",
        ],
        github: "proprietary",
        projectUrl: "",
        projectDemo: "",
        images: [],
        pinned: false,
    },
    {
        id: "flower_classifier",
        name: "Flower Classifier",
        description: "An iOS app that can identify the type of flower",
        details: "Flower Classifier is an iOS app that uses Apple's coreML APIS to identify the type of Flower from its clicked picture. The App converts a pre-trained caffe model (Oxford 102 dataset) to MLModel using coreMLTools framework from apple. The app also shows information about the indentified flower using Wikipedia's APIs.\nDeveloped as an attempt to explore Machine Learning APIs offered by apple for its iOS SDK.",
        associatedWith: "Personal Project",
        duration: "February 2019",
        domain: "iOS Development",
        primaryLanguage: "Swift",
        skills: [
            "iOS",
            "Model-View-Controller",
            "Machine Learning"
        ],
        technologiesUsed: [
            "Git",
            "CoreML",
        ],
        github: "https://github.com/psx95/iOS-FlowerClassifier",
        projectUrl: "",
        projectDemo: "",
        images: [],
        pinned: false,
    },
    {
        id: "todoey",
        name: "Todoey",
        description: "An iOS based To-do list app",
        details: "Todoey is a simple iOS application that allows users to create to-do lists.\nThe app demonstrates the use of various Persistent Local Stoarge Options like UserDefaults, NSUserData, Core Data & Realm to store and retrieve user lists.\nDeveloped as an attempt to learn iOS Development with Swift.",
        associatedWith: "Personal Project",
        duration: "December 2018",
        domain: "iOS Development",
        primaryLanguage: "Swift",
        skills: [
            "iOS",
            "Model-View-Controller",
        ],
        technologiesUsed: [
            "Git",
            "Chameleon Framework",
            "Realm",
            "Core Data",
        ],
        github: "https://github.com/psx95/Todoey",
        projectUrl: "",
        projectDemo: "",
        images: [],
        pinned: false,
    },
    {
        id: "flash_chat",
        name: "Flash Chat",
        description: "Flash Chat is an iOS based realtime chat application.",
        details: "Flash Chat is an iOS based realtime chat application that allows users to send and receive messages to/from a common chat room. The app features a simple login system built on top of Firbase APIs. The messages are also stored using Firebase, in its realtime database.\nDeveloped as an attempt to learn iOS Development with Swift.",
        associatedWith: "Personal Project",
        duration: "December 2018",
        domain: "iOS Development",
        primaryLanguage: "Swift",
        skills: [
            "iOS",
            "Model-View-Controller",
            "Asynchronous Programming",
        ],
        technologiesUsed: [
            "Git",
            "Chameleon Framework",
            "Firebase",
        ],
        github: "https://github.com/psx95/iOS-ChatApp",
        projectUrl: "",
        projectDemo: "",
        images: [],
        pinned: false,
    },
    {
        id: "bulls_eye",
        name: "Bulls Eye!!",
        description: "Bull's Eye - simple & fun iOS mobile game",
        details: "Bull's Eye is a simple iOS game that allows user to manipulate a slider to place near a certain value (randomly generated) to score points. The user has to place the slider as near to the generated value as possible to score maximum points. The further user is from the generated value, the less points he scores.\nDeveloped as an attempt to learn iOS development with Swift.",
        associatedWith: "Personal Project",
        duration: "December 2018",
        domain: "iOS Development",
        primaryLanguage: "Swift",
        skills: [
            "iOS",
            "Model-View-Controller"
        ],
        technologiesUsed: [
            "Git",
        ],
        github: "https://github.com/psx95/iOSBullsEye",
        projectUrl: "",
        projectDemo: "",
        images: [],
        pinned: false,
    },
    {
        id: "smart_tractor",
        name: "SIMHA Kit (formerly Carnot Smart Tractor)",
        description: "Simha Kit is a smart telematics solution targeted towards people who own a tractor",
        details: "Simha Kit  is an Android app that connects a user's tractor to their phone and lets them manage the health, security and activity of thier Tractor. The primary features the app offers are - location tracking, fuel consumption analysis, report generation (for work done on tractor) and instant alerts about the health & security of the tractor.\nThe app is built with a scalable & testable architecture and follows the Model-View-Presenter design pattern for allowing a clear separation of concerns. Built using the best Android practices in mind, the app is very performance oriented, designed to run smoothly on entry level devices of any screen size. An 'offline-first' approach has also been used to make sure that the user always has access to data - even when running in low network coverage areas along with other optimisations to reduce the app size.",
        associatedWith: "Software Development Engineer (Android Lead), Carnot Technologies Pvt. Ltd.",
        duration: "February 2018 - October 2018",
        domain: "Android Development",
        primaryLanguage: "Java",
        skills: [
            "Android",
            "Data Structures",
            "Database Design",
            "Design Patterns",
            "Object Oriented Design",
            "Multithreading",
            "Networking",
        ],
        technologiesUsed: [
            "Git",
            "RealmDB",
            "Firebase",
            "Dagger2",
            "View Binding",
            "JUnit",
        ],
        github: "proprietary",
        projectUrl: "https://play.google.com/store/apps/details?id=com.carnot.traclytics.simha&hl=en_US&gl=US",
        projectDemo: "",
        images: [],
        pinned: true,
    },
    {
        id: "quickshare",
        name: "Quickshare",
        description: "Quickshare is a web app that allows instant sharing of small textual information from your Android phone to your Desktop.",
        details: "The project comprises of a total of 3 parts - A web server backend, A client app on Android & a web client app.\nThe client app on Android would create an additional option in the floating text selection toolbar (The toolbar that appears when you select any text on Android 6.0 & above) named 'QUICKSHARE' selecting this opetion would send the selected text on to your desktop - implementing it this way eliminates the need of opening the app every time you need to share something. The web client app would then show a dekstop notification - indicating that you received something from the Android client.\nBoth clients use the REST APIs implemented on the web backend server - these APIs allow for sending & receiving text. Firebase Realtime Database is used to store these messages. For this system to work, the user must be logged in to both the clients with the same account. The app currently allows logging-in only using the Google Sign-In option.",
        associatedWith: "Personal Project",
        duration: "April 2018 - July 2018",
        domain: "Web Development",
        primaryLanguage: "Javascript",
        skills: [
            "Android",
            "Database Design",
            "Website Design",
            "Multithreading",
            "Networking",
            "REST APIs",
        ],
        technologiesUsed: [
            "Git",
            "Firebase",
            "Node.JS",
            "Bootstrap4",
            "HTML5/CSS3",
        ],
        github: "private",
        projectUrl: "https://quickshare-web.herokuapp.com/",
        projectDemo: "",
        images: [],
        pinned: false,
    },
    {
        id: "hidden_layout",
        name: "HiddenLayout",
        description: "HiddenLayout is an Android library that provides with views that reveal hidden options on swiping",
        details: "HiddenLayout creates a view using two layouts overlapped over each other - when you slide the upper-layout, the layout underneath is visible. This is very much similar to the slide animations we often see in iOS apps like iMessages. To make it work, all you need to do is provide two separate layouts and provide them to the Custom View generated by the library.",
        associatedWith: "Personal Project",
        duration: "April 2018",
        domain: "Android Development",
        primaryLanguage: "Java",
        skills: [
            "Android",
            "Object Oriented Design",
            "API Design",
            "Animation",
        ],
        technologiesUsed: [
            "Git",
            "Android Animations",
            "Maven",
            "Gradle",
        ],
        github: "https://github.com/psx95/HiddenLayout",
        projectUrl: "https://bintray.com/psx95/HiddenLayoutView/hidden-layout-view/0.1.1",
        projectDemo: "https://github.com/psx95/HiddenLayout/blob/master/README.md",
        images: [],
        pinned: false,
    },
    {
        id: "rotate_screen",
        name: "Rotate Screen",
        description: "Rotate Screen is an application that allows forced orientation change on devices",
        details: "A very simple android app utility that allows a user to force change the orientation of his Android device. Developed as a fix specifically for devices with faulty orientation sensors and a personal need 😁",
        associatedWith: "Personal Project",
        duration: "February 2018",
        domain: "Android Development",
        primaryLanguage: "Java",
        skills: [
            "Android",
        ],
        technologiesUsed: [
            "Git",
        ],
        github: "https://github.com/psx95/RotateScreen",
        projectUrl: "",
        projectDemo: "",
        images: [],
        pinned: false,
    },
    {
        id: "db_perf_analyser",
        name: "Database Performance Analyser",
        description: "A GUI based tool for query performance analysis on MySQL, MongoDB, Cassandra & PostgreSQL",
        details: "Database Performance Analyser is a tool that can be used to measure the performance of different databases by running the same set of queries on them over the same data multiple times and then averaging out the query execution time. The project relies on the connectors for the given databases for Java and uses these connectors to run queries against these databases. Currently, the project has static queries (meaning the end user cannot modify these)as queries have to be converted to their java equivanlent using these connectors. However, the end user does have the option to specify which query to run and how many times should it run.\n The application generates a visual plot of the runtimes to help effectively view how the query performed after every run.",
        associatedWith: "B.Tech Computer Science & Engineering - Jaypee Institute of Information Technology",
        duration: "November 2017 - February 2018",
        domain: "Desktop App Development",
        primaryLanguage: "Java",
        skills: [
            "Database Design",
            "MySQL",
            "MongoDB",
            "PostgreSQL",
            "Multithreading",
            "Object Oriented Design",
        ],
        technologiesUsed: [
            "JavaSE",
            "JavaFX",
        ],
        github: "https://github.com/psx95/DatabaseGUI",
        projectUrl: "",
        projectDemo: "",
        images: [],
        pinned: false,
    },
    {
        id: "polyglot_persistence",
        name: "Polyglot Persistence",
        description: "A web app that demonstrates the use of 'polyglot persistence'",
        details: "A Java based web app that demonstrates the use of 'polyglot persistence' - saving different kinds of data into datastores best suited for them. In this simple project data from a single web page form is stored into separated data stores upon submission of the form. The data stores connected were MongoDB & MySQL. The web interface also allowed basic CRUD operations on the data collected by this form - which was basically a survey containing a few subjective questions & user's demographic information.\nThe project uses Spring Framework and relies on the Spring Data JPA for implementing data persistence.",
        associatedWith: "B.Tech Computer Science & Engineering - Jaypee Institute of Information Technology",
        duration: "November 2017 - February 2018",
        domain: "Web Development",
        primaryLanguage: "Java",
        skills: [
            "Database Design",
            "MySQL",
            "MongoDB",
            "Model-View-Controller",
        ],
        technologiesUsed: [
            "Spring MVC",
            "Spring Data",
            "JSP",
        ],
        github: "https://github.com/psx95/PolyglotPersistenceSpringData",
        projectUrl: "",
        projectDemo: "",
        images: [],
        pinned: false,
    },
    {
        id: "snake_game",
        name: "Snake Game",
        description: "An attempt to recreate the classic Snake Game on Desktop",
        details: "The classic Snake Game created using graphics in C. The game is built using minimal libraries with the graphics being only handled by the graphics.h library. The game contains 2 different layouts (placing obstacles on screen for the snake) and 3 different difficulty settings - with increase in each difficulty setting the speed with which the snake moves increases. All these options are configurable via a graphical, in-game settings screen.\nThe entire application can be navigated using keyboard. The game also contains a help section which displays how to play the game and scoring rules.\nThe application is also capable of maintaining high scores along with the player names. Since no database is involved these highscores are maintained using simple un-encrypted files.\nYou need the TurboC++ compiler to run this application.",
        associatedWith: "B.Tech Computer Science & Engineering - Jaypee Institute of Information Technology",
        duration: "October 2016 - November 2016",
        domain: "Game Development",
        primaryLanguage: "C",
        skills: [
            "C Graphics",
            "Data Structures",
        ],
        technologiesUsed: [
            "TurboC++",
        ],
        github: "https://github.com/psx95/SnakeGame",
        projectUrl: "",
        projectDemo: "",
        images: [],
        pinned: false,
    },
]